// extracted by mini-css-extract-plugin
export default {"container":"SelectInput_container__UggVv","checkbox-container":"SelectInput_checkbox-container__1HXqZ","loader":"SelectInput_loader__qMaWP"};